import config from "react-global-configuration";
import { AESEncryption, AESDecryption } from "./AesUtil";
var serviceUrl = config.get('apidomain');
var IDServerUrl = config.get('identityDomain');
var projectID = config.get('projectID');
var identityClientID = config.get('identityClientID');

export const CommonGet = (url, queryString) => {
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        if (queryString != null) {
            request.open("GET", serviceUrl + url +"?"+ AESEncryption(queryString));
        } else {
            request.open("GET", serviceUrl + url);
        }

        request.setRequestHeader("Content-type", "application/json; charset=utf-8");
        //request.setRequestHeader('Authorization', 'Bearer ' + window.access_token);
        request.setRequestHeader('Access-Control-Allow-Methods', '*');
        request.setRequestHeader('Accept-Language', 'en-US');
        request.onload = () => {
            if (request.response === 'Token Time Exceed') {
                window.logout.logout();
            }
            else {
                if (request.status >= 200 && request.status < 300) {
                    resolve(JSON.parse(AESDecryption(request.response)));
                } else {
                    reject(request.statusText);
                }
            }
        };
        request.onerror = () => {
            reject(request.statusText);
        };
        request.send();
    });
};

export const CommonGetIDServer = (url, queryString) => {
    let queryStringWithProject;

    if (queryString != null) {
        queryStringWithProject = queryString + "&projectId=" + projectID;
    }
    else {
        queryStringWithProject = "projectId=" + projectID;
    }

    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();

        request.open("GET", IDServerUrl + url + "?" + AESEncryption(queryStringWithProject));
        //request.open("GET", IDServerUrl + url + "?" + queryStringWithProject);

        request.setRequestHeader("Content-type", "application/json; charset=utf-8");
        request.setRequestHeader('Authorization', 'Bearer ' + window.access_token);
        request.setRequestHeader('Access-Control-Allow-Origin', '*');
        request.setRequestHeader('Access-Control-Allow-Methods', '*');
        request.setRequestHeader('Accept-Language', 'en-US');
        request.onload = () => {
            if (request.response === 'Token Time Exceed') {
                window.logout.logout();
            }
            else {
                if (request.status >= 200 && request.status < 300) {
                    //console.log(AESDecryption(request.response));
                    resolve(JSON.parse(AESDecryption(request.response)));
                    //resolve(JSON.parse(request.response));
                } else {
                    reject(request.statusText);
                }
            }
        };
        request.onerror = () => {
            reject(request.statusText);
        };
        request.send();
    });
};



export const CommonPost = (url, queryString, body) => {
    const encryptedResult = AESEncryption(JSON.stringify(body));
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        if (queryString != null) {
            request.open("POST", serviceUrl + url + "?" + AESEncryption(queryString));
        } else {
            request.open("POST", serviceUrl + url);
        }

        request.setRequestHeader("Content-type", "application/json; charset=utf-8");
        //request.setRequestHeader('Authorization', 'Bearer ' + window.access_token);
        request.setRequestHeader('Access-Control-Allow-Methods', '*');
        request.setRequestHeader('Accept-Language', 'en-US');
        request.onload = () => {
            if (request.response === 'Token Time Exceed') {
                window.logout.logout();
            }
            else {
                if (request.status >= 200 && request.status < 300) {
                    resolve(JSON.parse(AESDecryption(request.response)));
                } else {
                    reject(request.statusText);
                }
            }
        };
        request.onerror = () => {
            reject(request.statusText);
        };
        request.send(encryptedResult);
    });
};




export const CommonPostIDServer = (url, queryString, body) => {


    let queryStringWithProject;

    if (queryString != null) {
        queryStringWithProject = queryString + "&projectId=" + projectID;
    }
    else {
        queryStringWithProject = "projectId=" + projectID;
    }

    let bodyString = JSON.stringify(body);

    const encryptedResult = AESEncryption(bodyString);
    //const encryptedResult = bodyString;
    return new Promise((resolve, reject) => {

        let request = new XMLHttpRequest();
        request.open("POST", IDServerUrl + url + "?" + AESEncryption(queryStringWithProject));
        //request.open("POST", IDServerUrl + url + "?" + queryStringWithProject);


        request.setRequestHeader("Content-type", "application/json;");
        request.setRequestHeader('Authorization', 'Bearer ' + window.access_token);
        request.setRequestHeader('Access-Control-Allow-Origin', '*');
        request.setRequestHeader('Access-Control-Allow-Methods', '*');
        request.setRequestHeader('Accept-Language', 'en-US');

        request.onload = () => {
            if (request.response === 'Token Time Exceed') {
                window.logout.logout();
            }
            else {
                if (request.status >= 200 && request.status < 300) {
                    // resolve(JSON.parse(request.response));
                    resolve(JSON.parse(AESDecryption(request.response)));
                } else {
                    reject(request.statusText);
                }
            }
        };
        request.onerror = () => {
            reject(request.statusText);
        };
        request.send(encryptedResult);
    });

};




